module.exports = __webpack_public_path__ + "static/media/level_21-22.fb2c7305.jpg";